import Transpos from "./TransposApp";

// Руководство:

// в tasks - идет добавление заданий, делящихся на раунды (ссылки создаются автоматически, с названием заданным id)

// id — идентификатор уровня. Используется в адресной строке.
// type — тип задания. Используется в адресной строке.
// 1 - отображение слогов в обратном порядке (слога разделяются символом "|").
// 2 - транспонирование первой и последней буквы в каждом слове. Блоки по 2 или по 3 буквы (блоки разделяются символом "|").
// rounds — массив раундов.
// Каждый раунд содержит:
// • textBySyllables — массив строк загадки. Слова разделяются на слоги символом "|".
// • correctAnswer — правильный ответ на загадку.

// Регистр букв в textBySyllables и correctAnswer не имеет значения.
// Имеется тест для проверки валидности всего, что задается в tasks

const tasks = [
  //*начало задания
  {
    id: "1", // название задания (будет как первый аргумент после названия игры в строке поиска )
    type: "1",
    name: "Шифр офени", // название задания (будет отображаться в заголовке окна)
    // массив раундов
    rounds: [
      // начало 1 раунда
      {
        textBySyllables: [
          "Ле|жит до|щеч|ка у эк|ра|на",
          "Бук|вам кноп|кам о|на ма|ма!",
          "Зна|ет рус|ский ал|фа|вит",
          "И ан|глий|ским у|ди|вит -",
          "О|чень ум|на|я на|ту|ра!",
          "Э|то что?",
        ], // массив строк загадки
        correctAnswer: "Клавиатура", //правильный ответ на загадку
      },
      // конец 1 раунда

      {
        textBySyllables: [
          "По|мо|га|ет о|на мне",
          "На ком|пью|тер|ном сто|ле.",
          "Я уп|рав|ля|ю лов|ко",
          "Ко|лё|си|ком и кноп|кой.",
        ],
        correctAnswer: "Мышь",
      },
    ],
  },
  //*конец задания
  {
    id: "2", // название задания (будет как первый аргумент после названия игры в строке поиска )
    type: "1",
    name: "Шифр офени",
    // массив раундов
    rounds: [
      // начало 1 раунда
      {
        textBySyllables: [
          "Он в ком|пью|те|ре - как мозг,",
          "Сре|ди мик|ро|схем про|рос.",
          "Быст|ро де|ла|ет рас|чё|ты",
          "У не|го пол|но ра|бо|ты!",
        ], // массив строк загадки
        correctAnswer: "Процессор", //правильный ответ на загадку
      },
      // конец 1 раунда

      {
        textBySyllables: [
          "Он бы|стре|е че|ло|ве|ка",
          "Пе|ре|мно|жит два чис|ла,",
          "В нём сто раз би|бли|о|те|ка",
          "По|ме|сти|ться бы смог|ла,",
          "Толь|ко там от|крыть воз|мож|но",
          "Сто о|ко|шек за ми|ну|ту.",
          "У|га|дать сов|сем не слож|но,",
          "Что за|гад|ка про",
        ],
        correctAnswer: "Компьютер",
      },
    ],
  },
  {
    id: "3", // 1 записка
    type: "1",
    name: "Шифр офени",
    // массив раундов
    rounds: [
      {
        textBySyllables: [
          "Бро|си|лись в по|го|ню за бе|лой и",
          "лох|ма|той по|дру|гой.",
        ], // массив строк загадки
        correctAnswer: "далее", //правильный ответ на загадку
      },
    ],
  },
  {
    id: "4", // 1 записка
    type: "1",
    name: "Шифр ноипш",
    rounds: [
      {
        textBySyllables: [
          "о|п|о|в|е|щ|а|т|ь о к|а|ж|д|о|м ш|а|г|е.",
        ], // массив строк загадки
        correctAnswer: "далее", //правильный ответ на загадку
      },
    ],
  },
  {
    id: "5", // 2 записка
    type: "1",
    name: "Шифр ноипш",
    rounds: [
      {
        textBySyllables: [
          "В|д|а|л|е|к|е н|е|и|з|в|е|с|т|н|ы|й",
        ], // массив строк загадки
        correctAnswer: "далее", //правильный ответ на загадку
      },
    ],
  },
  {
    id: "7", // 2 записка
    type: "1",
    name: "Шифр офени",
    rounds: [
      {
        textBySyllables: [
          "Доб|ра|лись до за|го|на с о|веч|ка|ми.",
          "Вы|чис|лить на|шу зна|ко|му|ю сре|ди",
          "о|вец не у|да|лось.",
        ], // массив строк загадки
        correctAnswer: "далее", //правильный ответ на загадку
      },
    ],
  },
  {
    id: "8", // 3 записка
    type: "1",
    name: "Шифр офени",
    rounds: [
      {
        textBySyllables: [
          "О|ка|за|лись ря|дом с пру|дом",
          "с зо|ло|ты|ми рыб|ка|ми."        
        ], // массив строк загадки
        correctAnswer: "далее", //правильный ответ на загадку
      },
    ],
  },
  {
    id: "10", // 3 записка
    type: "1",
    name: "Шифр ноипш",
    rounds: [
      {
        textBySyllables: [
          "В|о|д|а ч|у|д|е|с|н|а|я.",
          "Б|е|г|л|я|н|к|у н|е в|с|т|р|е|т|и|л|и.",
          "П|р|о|д|о|л|ж|а|е|м п|о|и|с|к."
        ], // массив строк загадки
        correctAnswer: "далее", //правильный ответ на загадку
      },
    ],
  },
  {
    id: "11", // 4 записка
    type: "1",
    name: "Шифр офени",
    rounds: [
      {
        textBySyllables: [
          "Про|шли че|рез про|се|ку",
          "в вол|шеб|ном ле|су.",
        ], // массив строк загадки
        correctAnswer: "далее", //правильный ответ на загадку
      },
    ],
  },
  {
    id: "12", // 4 записка
    type: "1",
    name: "Шифр ноипш",
    rounds: [
      {
        textBySyllables: [
          "к|а|ж|д|ы|й п|о|в|о|р|о|т т|р|о|п|ы.",
          "О|н|а к|а|к с|к|в|о|з|ь з|е|м|л|ю п|р|о|в|а|л|и|л|а|с|ь."
        ], // массив строк загадки
        correctAnswer: "далее", //правильный ответ на загадку
      },
    ],
  },
  {
    id: "13", // 5 записка
    type: "1",
    name: "Шифр офени",
    rounds: [
      {
        textBySyllables: [
          "Встре|ти|ли ё|жи|ка.",
          "У|да|лось раз|ве|дать,",
          "что ро|га|ту|ю ви|де|ли",
          "о|ко|ло по|ля|ны",
        ], // массив строк загадки
        correctAnswer: "далее", //правильный ответ на загадку
      },
    ],
  },
  {
    id: "14", // 5 записка
    type: "1",
    name: "Шифр ноипш",
    rounds: [
      {
        textBySyllables: [
          "п|о|р|т|а|л|а.",
        ], // массив строк загадки
        correctAnswer: "далее", //правильный ответ на загадку
      },
    ],
  },
  {
    id: "15", // 6 записка
    type: "1",
    name: "Шифр ноипш",
    rounds: [
      {
        textBySyllables: [
          "п|р|ы|ж|к|а|м|и д|о|с|к|а|к|а|л|и д|о п|о|л|я|н|ы.",
        ], // массив строк загадки
        correctAnswer: "далее", //правильный ответ на загадку
      },
    ],
  },
  {
    id: "16", // 6 записка
    type: "1",
    name: "Шифр офени",
    rounds: [
      {
        textBySyllables: [
          "Бе|ла|я вер|ти|хво|стка, у|ви|дев нас,",
          "пус|ти|лась на|у|тёк",
          "и про|па|ла из ви|ду.",
        ], // массив строк загадки
        correctAnswer: "далее", //правильный ответ на загадку
      },
    ],
  },
  {
    id: "17", // 7 записка
    type: "1",
    name: "Шифр ноипш",
    rounds: [
      {
        textBySyllables: [
          "Н|а|с|т|и|г|н|у|т|ь р|е|з|в|у|ю у|д|а|л|о|с|ь",
          "в г|о|с|т|я|х у А|л|ё|н|к|и.",
          "Х|и|т|р|ю|г|а п|ь|е|т ч|а|й с к|а|п|у|с|т|н|ы|м",
        ], // массив строк загадки
        correctAnswer: "далее", //правильный ответ на загадку
      },
    ],
  },
  {
    id: "18", // 7 записка
    type: "1",
    name: "Шифр офени",
    rounds: [
      {
        textBySyllables: [
          "Сы|щи|ки у|то|ми|лись,",
          "ну|жен от|дых.",
        ], // массив строк загадки
        correctAnswer: "далее", //правильный ответ на загадку
      },
    ],
  },


  {
    id: "101",
    type: "1",
    name: "Шифр ноипш",
    rounds: [
      {
        textBySyllables: [
          "О|н|а в|с|ё п|о|м|н|и|т н|а х|о|д|у,",
          "П|о|к|а к|о|м|п|ь|ю|т|е|р н|а в|и|д|у!",
          "И|г|р|у, к|а|р|т|и|н|к|у, в|к|л|а|д|к|у, т|е|к|с|т",
          "О|н|а в|к|л|ю|ч|а|е|т в с|в|о|й к|о|н|т|е|к|с|т.",
          "Н|о с|т|о|и|т в|ы|к|л|ю|ч|и|т|ь п|р|и|б|о|р -",
          "С|т|и|р|а|е|т п|а|м|я|т|ь с|в|о|й у|з|о|р.",
        ],
        correctAnswer: "Оперативная память",
      },
      {
        textBySyllables: [
          "Э|т|о|т с|е|й|ф в|н|у|т|р|и ж|и|в|ё|т,",
          "Н|и|ч|е|г|о н|е п|р|о|п|а|д|ё|т!",
          "И|г|р|ы, ф|и|л|ь|м|ы и к|а|р|т|и|н|к|и",
          "С|о|х|р|а|н|и|т о|н б|е|з з|а|п|и|н|к|и.",
          "Д|а|ж|е е|с|л|и с|в|е|т о|т|к|л|ю|ч|и|ш|ь,",
          "В|с|ё н|а|з|а|д о|п|я|т|ь п|о|л|у|ч|и|ш|ь.",
        ],
        correctAnswer: "Жёсткий диск",
      },
    ],
  },

  {
    id: "102",
    type: "1",
    name: "Шифр ноипш",
    rounds: [
      {
        textBySyllables: [
          "В э|т|о|й к|о|р|о|б|к|е ж|е|л|е|з|н|о|й и в|а|ж|н|о|й",
          "П|р|я|ч|е|т|с|я м|о|з|г э|л|е|к|т|р|о|н|н|ы|й о|т|в|а|ж|н|о!",
          "П|а|м|я|т|ь х|р|а|н|и|т|с|я т|а|м, д|и|с|к|и к|р|у|т|я|т|с|я,",
          "И|г|р|ы и м|у|л|ь|т|и|к|и б|ы|с|т|р|о з|а|п|у|с|т|я|т|с|я.",
          "В|е|н|т|и|л|я|т|о|р в|н|у|т|р|и в|е|е|т п|р|о|х|л|а|д|о|й,",
          "Ч|т|о|б н|е п|е|р|е|г|р|е|л|с|я. К|а|к з|в|а|т|ь е|г|о",
          "н|а|д|о|?",
        ],
        correctAnswer: "Системный блок",
      },
      {
        textBySyllables: [
          "С|а|м п|о с|е|б|е о|н н|е м|ы|с|л|и|т, н|е с|у|д|и|т,",
          "Н|о б|е|з н|е|г|о н|а|м п|о|н|я|т|н|о н|е б|у|д|е|т,",
          "Ч|т|о т|а|м п|р|о|ц|е|с|с|о|р с|ч|и|т|а|е|т в т|и|ш|и.",
          "П|р|о|в|о|д п|о|д|к|л|ю|ч|и|ш|ь — и ч|у|д|о в|е|р|ш|и!",
          "Ц|и|ф|р|ы и к|о|д п|р|е|в|р|а|щ|а|е|т о|н в ц|в|е|т,",
          "В|ы|д|а|с|т к|а|р|т|и|н|к|у, о|б|о|и, с|ю|ж|е|т.",
          "Э|т|о л|и|ц|о э|л|е|к|т|р|о|н|н|ы|х с|и|с|т|е|м,",
          "Г|л|а|в|н|ы|й т|р|а|н|с|л|я|т|о|р к|о|м|п|ь|ю|т|е|р|н|ы|х т|е|м.",
        ],
        correctAnswer: "Монитор",
      },
    ],
  },
];

// Дополнительные параметры в адресной строке:
// Здесь можно редактировать запись в строке поиска, например, названия игры (изначально Transpos)

// Формы записи аргументов (изначальных):
// /r    — случайный порядок раундов.
// /help — отображает кнопку «Разбить на слоги».
//
// Примеры:
// /Transpos/1/1
// /Transpos/1/1/r
// /Transpos/1/1/help
// /Transpos/1/1/r/help

// (число 1 в примере - это аргумент id, который задается в tasks)'

// Порядок /r и /help значения не имеет.

// все ссылки автоматически раскрываются (передаются) в index.tsx

const transposRoutes = tasks.flatMap((task) => [
  {
    path: `/Transpos/${task.id}/${task.type}`,
    element: (
      <Transpos
        random={false}
        rounds={task.rounds}
        help={false}
        type={task.type}
        name={task.name}
      />
    ),
  },
  {
    path: `/Transpos/${task.id}/${task.type}/help`,
    element: (
      <Transpos
        random={false}
        rounds={task.rounds}
        help={true}
        type={task.type}
        name={task.name}
      />
    ),
  },
  {
    path: `/Transpos/${task.id}/${task.type}/r`,
    element: (
      <Transpos
        random={true}
        rounds={task.rounds}
        help={false}
        type={task.type}
        name={task.name}
      />
    ),
  },
  {
    path: `/Transpos/${task.id}/${task.type}/r/help`,
    element: (
      <Transpos
        random={true}
        rounds={task.rounds}
        help={true}
        type={task.type}
        name={task.name}
      />
    ),
  },
  {
    path: `/Transpos/${task.id}/${task.type}/help/r`,
    element: (
      <Transpos
        random={true}
        rounds={task.rounds}
        help={true}
        type={task.type}
        name={task.name}
      />
    ),
  },
]);
export default transposRoutes;
